define('headerUsersListUserView',[
  'module',
  'underscore',
  'marionette',
  'userView',
  'template!headerUsersListUserView'
], function (
  Module,
  _,
  Marionette,
  UserView,
  Tpl
) {
  'use strict';

  Module.exports = Marionette.LayoutView.extend({
    className: 'header-users-list-user-view',
    template: Tpl,

    regions: {
      userRegion: '.user-region'
    },

    serializeData: function () {
      var data = {};

      data.name = '';
      if(this.model.get('firstName'))
        data.name += this.model.get('firstName');
      if(this.model.get('lastName')) {
        if(data.name)
          data.name += ' ';

        data.name += this.model.get('lastName');
      }        
     
      return data;      
    },

    onShow: function () {   
      this.userView = new UserView({
        model: this.model
      });
      this.getRegion('userRegion').show(this.userView);
    }
  });
});
